import { VNode } from "preact"
import { RouteProps, Switch } from "wouter-preact"

import { Sidebar } from "@/app/sidebar"
import { FileDisputeDrawer } from "@/dispute/file_dispute_drawer"
import { BumpMessageDialog } from "@/bump_message/bump_message_dialog"
import { BulkCodingWizProgress } from "@/accounting/BulkCodingWizProgress"

export function Container({ children }: { children: Array<VNode<RouteProps>> }) {
  return (
    <div class="flex min-h-screen">
      <Sidebar />
      <main class="min-w-0 flex-1 py-4">
        <FileDisputeDrawer />
        <BumpMessageDialog />
        <BulkCodingWizProgress />
        <Switch children={children} />
      </main>
    </div>
  )
}
